export function injectScriptTag(src: string, id: string): Promise<boolean> {
	// eslint-disable-next-line consistent-return
	return new Promise((resolve, reject) => {
		if (document.getElementById(id)) {
			// Already exists
			return resolve(true);
		}
		const allScripts = document.getElementsByTagName('script');
		const lastScriptTag =
			document.getElementsByTagName('script')[allScripts.length - 1];
		const scriptTag = document.createElement('script');
		scriptTag.id = id; // To avoid inserting the same thing more then once
		scriptTag.onload = function () {
			return resolve(true);
		};
		scriptTag.onerror = (error) => {
			return reject(error);
		};
		scriptTag.src = src;
		if (lastScriptTag && lastScriptTag.parentNode) {
			lastScriptTag.parentNode.insertBefore(
				scriptTag,
				lastScriptTag.nextSibling
			);
		}
	});
}

export function injectStyleTag(href: string, id: string): Promise<boolean> {
	// eslint-disable-next-line consistent-return
	return new Promise((resolve, reject) => {
		if (document.getElementById(id)) {
			// Already exists
			return resolve(true);
		}
		const headEl = document.getElementsByTagName('head')[0];
		const linkTag = document.createElement('link');
		linkTag.id = id; // To avoid inserting the same thing more then once
		linkTag.rel = 'stylesheet';
		linkTag.type = 'text/css';
		linkTag.onload = function () {
			return resolve(true);
		};
		linkTag.onerror = (error) => {
			return reject(error);
		};
		linkTag.href = href;
		linkTag.media = 'all';
		headEl.appendChild(linkTag);
	});
}

export function htmlToElement(htmlString: string): HTMLElement {
	const wrapper = document.createElement('div');
	wrapper.innerHTML = htmlString;
	document.body.appendChild(wrapper);
	const el = wrapper.firstChild;
	if (el && wrapper.parentNode) {
		const elClone = el.cloneNode(true);
		wrapper.parentNode.removeChild(wrapper);

		return elClone as HTMLElement;
	}
	return wrapper;
}

export function htmlToFragment(htmlString: string): DocumentFragment {
	const fragment = document.createDocumentFragment();
	const wrapper = document.createElement('div');
	wrapper.innerHTML = htmlString;

	Array.from(wrapper.childNodes).forEach((child) =>
		fragment.appendChild(child)
	);
	return fragment;
}

export function getFirstHumanReadableTextFromHtml(
	htmlString: string
): undefined | string {
	// TODO: Pre-process htmlString to remove any tags which
	// might unnecessarily load resources (e.g. video, img, picture)
	const articleMarkup = htmlToFragment(htmlString);

	if (!articleMarkup) {
		return undefined;
	}

	const [firstTextEl] = Array.from(articleMarkup.children).filter((child) => {
		return (
			(child as HTMLElement).innerText &&
			(child as HTMLElement).innerText.length
		);
	});

	if (firstTextEl) {
		return (firstTextEl as HTMLElement).innerText;
	}

	return undefined;
}

export function getTransitionDurationFromElement(element: HTMLElement): number {
	const styles = window.getComputedStyle(element);
	return (
		parseFloat(
			styles.getPropertyValue('transition-duration').split(',')[0].split('s')[0]
		) * 1000
	);
}

export function createAppElement(elId: string): HTMLDivElement {
	const el = document.createElement('div');
	el.setAttribute('id', elId);
	el.setAttribute('class', 'chatbot-widget');
	el.setAttribute('data-tag-section', 'chatbot widget');
	el.setAttribute('role', 'region');
	el.setAttribute('aria-labelledby', 'chatbot-title');
	document.body.appendChild(el);
	return el;
}
